import { render, staticRenderFns } from "./TheFooterPartnersList.vue?vue&type=template&id=6c7f2f26&scoped=true"
import script from "./TheFooterPartnersList.vue?vue&type=script&lang=js"
export * from "./TheFooterPartnersList.vue?vue&type=script&lang=js"
import style0 from "./TheFooterPartnersList.vue?vue&type=style&index=0&id=6c7f2f26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7f2f26",
  null
  
)

export default component.exports